import { FC } from "react";
import styles from "./Head.module.sass";

const Head: FC = () => {
	return (
		<div className={styles.head}>
			<div>№</div>
			<div>Объект</div>
			<div>Название документа</div>
			<div>Дата утверждения</div>
			<div>Дата формирования</div>
			<div>Кто загрузил</div>
		</div>
	);
};

export default Head;
